import weixin from './weixin'

export default {
  weixin,
}